import { render, staticRenderFns } from "./RegistroHuella.vue?vue&type=template&id=49eeae01"
import script from "./RegistroHuella.vue?vue&type=script&lang=js"
export * from "./RegistroHuella.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports